import { supabase } from './supabase';
import { t } from '../data/translations';

export interface GuestbookMessage {
  id?: number;
  author: string;
  message: string;
  created_at?: string;
}

export interface GuestbookServiceResponse {
  success: boolean;
  data?: GuestbookMessage | GuestbookMessage[];
  error?: string;
}

class GuestbookService {
  async getAllMessages(): Promise<GuestbookServiceResponse> {
    try {
      const { data, error } = await supabase
        .from('guestbook')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Guestbook fetch error:', error);
        return {
          success: false,
          error: 'Failed to fetch messages'
        };
      }

      return {
        success: true,
        data: data as GuestbookMessage[]
      };

    } catch (error) {
      console.error('Guestbook fetch error:', error);
      return {
        success: false,
        error: 'Failed to fetch messages'
      };
    }
  }

  async addMessage(author: string, message: string): Promise<GuestbookServiceResponse> {
    try {
      const { data, error } = await supabase
        .from('guestbook')
        .insert([{ author: author.trim(), message: message.trim() }])
        .select()
        .single();

      if (error) {
        console.error('Guestbook add error:', error);
        return {
          success: false,
          error: 'Failed to add message'
        };
      }

      return {
        success: true,
        data
      };

    } catch (error) {
      console.error('Guestbook add error:', error);
      return {
        success: false,
        error: 'Failed to add message'
      };
    }
  }

  async deleteMessage(id: number): Promise<GuestbookServiceResponse> {
    try {
      const { error } = await supabase
        .from('guestbook')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Guestbook delete error:', error);
        return {
          success: false,
          error: 'Failed to delete message'
        };
      }

      return {
        success: true
      };

    } catch (error) {
      console.error('Guestbook delete error:', error);
      return {
        success: false,
        error: 'Failed to delete message'
      };
    }
  }

  // Получить сообщения с пагинацией
  async getMessagesWithPagination(page: number = 1, limit: number = 10): Promise<GuestbookServiceResponse> {
    try {
      const from = (page - 1) * limit;
      const to = from + limit - 1;

      const { data, error } = await supabase
        .from('guestbook')
        .select('*')
        .order('created_at', { ascending: false })
        .range(from, to);

      if (error) {
        console.error('Guestbook pagination error:', error);
        return {
          success: false,
          error: 'Failed to fetch messages'
        };
      }

      return {
        success: true,
        data: data as GuestbookMessage[]
      };

    } catch (error) {
      console.error('Guestbook pagination error:', error);
      return {
        success: false,
        error: 'Failed to fetch messages'
      };
    }
  }
}

export const guestbookService = new GuestbookService(); 